import { getConfig } from "@testing-library/react";
import { sizeInMB } from "./common-utils";

export const validateFileSize = (file) => {
  const maxSize = getConfig("maxFileSize");

  if (sizeInMB(file.size) > maxSize) {
    return { error: `File size cannot exceed more than ${maxSize}MB` };
  }
  return {};
};

export const validationMessage = {
  minimumValue: "minimum.value",
  maximumValue: "maximum.value",
  required: "Required!",
  invalidPhone: "invalid.phone",
  maxDecimals: "maximum.decimals",
};
